import { useMemo } from 'react';
import type { User } from '../types/user';
import { INITIAL_DISTRICTS, INITIAL_TOWNSHIPS, type GeoItem } from '../pages/setup/location/LocationData';

export function useCasePermissions(currentUser: User | null) {
  const permissionTownshipOptions = useMemo<GeoItem[]>(() => {
    if (!currentUser) return [];

    // 1. Admin Level -> Gets all Townships
    if (currentUser.role === 'ADMIN') {
      return INITIAL_TOWNSHIPS;
    }

    // 2. State Level (e.g., 's12' for Yangon)
    if (currentUser.role === 'USER' && currentUser.allowedStateIds) {
      // Find all districts belonging to the user's allowed states
      const allowedDistrictIds = INITIAL_DISTRICTS.filter((district) =>
        currentUser.allowedStateIds?.includes(district.parentId || '')
      ).map((district) => district.id);

      // Return all townships belonging to those districts
      return INITIAL_TOWNSHIPS.filter((township) =>
        allowedDistrictIds.includes(township.parentId || '')
      );
    }

    // // 3. District Level (e.g., 'd1')
    // if (currentUser.role === 'Reviewer' && currentUser.allowedDistrictIds) {
    //   return INITIAL_TOWNSHIPS.filter((township) =>
    //     currentUser.allowedDistrictIds?.includes(township.parentId || '')
    //   );
    // }

    return [];
  }, [currentUser]);



  // const permissionStateOptions = useMemo<GeoItem[]>(() => {
  //   if (!currentUser) return [];

  //   // 1. Admin Level -> Gets all Townships
  //   if (currentUser.role === 'ADMIN') {
  //     return INITIAL_STATES;
  //   }

  //   // 2. State Level (e.g., 's12' for Yangon)
  //   if (currentUser.role === 'USER' && currentUser.allowedStateIds) {
  //     // Find all districts belonging to the user's allowed states
  //     const allowedDistrictIds = INITIAL_DISTRICTS.filter((district) =>
  //       currentUser.allowedStateIds?.includes(district.parentId || '')
  //     ).map((district) => district.id);

  //     // Return all townships belonging to those districts
  //     return INITIAL_TOWNSHIPS.filter((township) =>
  //       allowedDistrictIds.includes(township.parentId || '')
  //     );
  //   }

  //   // 3. District Level (e.g., 'd1')
  //   if (currentUser.role === 'Reviewer' && currentUser.allowedDistrictIds) {
  //     return INITIAL_TOWNSHIPS.filter((township) =>
  //       currentUser.allowedDistrictIds?.includes(township.parentId || '')
  //     );
  //   }

  //   return [];
  // }, [currentUser]);

  return { permissionTownshipOptions };
}